export default __webpack_public_path__ + "static/404-7e6a58183b914d59328324f3b7cdb539.webp";